import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth-context";
import LoginPage from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import { Toaster } from "sonner";
import "@/index.css";

function Gate() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-[#F8FAFC] text-slate-900">
        <div className="pulse-dot" />
        <span className="ml-3 overline">Booting control room…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Dashboard />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="light" position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/*" element={<Gate />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
